var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card h-100"},[(_vm.options)?_c('TemplateDesignHeader',{attrs:{"context":_vm.options,"company":_vm.company},on:{"save":_vm.handleSave}}):_vm._e(),(_vm.loading)?_c('LoadingBar'):[_c('div',{staticClass:"card-body"},[_c('Designer',{attrs:{"template":_vm.currentTemplate,"parts":_vm.webparts}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }